export default {"src":"/_next/static/media/Biglogo.ebbba1a0.svg","height":131,"width":131,"blurWidth":0,"blurHeight":0};